/**
 * @module セキュリティ通知情報共通コンポーネント
 */
import CONSTANTS from '../../constants';

export default {
  name: 'SecurityNotification',
  data() {
    return {
      width: 0,
    };
  },
  props: {
    userAuthenticationType: {
      type: Number,
      default: 1,
      required: false,
    },
    securityStatus: String,
    warningOccurred: String,
    lockUp: String,
    notificationImage: String,
    isAlert: Boolean,
    isLockUp: Boolean,
    notificationCount: Number,
    notificationColor: String,
  },
  mounted() {
    this.width =
      this.$mq === 'pc' ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP;

    // 画面サイズ変更
    this.$watch('$mq', function () {
      this.changeItemLabelWidth(
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
      );
    });
  },
  /** @type {Methods} */
  methods: {
    /**
     * widthを調整
     * @param {object} width 幅
     */
    changeItemLabelWidth(width) {
      this.width = width;
    },
  },
};
